module.exports = __webpack_public_path__ + "img/aquarium-6359791_1920.2165e1cc.jpg";